module.exports = __webpack_public_path__ + "static/bottom-37e075bcd5aca6dc5df5b14972c30222.png";